@if (appearance === 'button') {
  <button mat-button [mat-menu-trigger-for]="sortOptionsMenu" [matTooltip]="'uix.grid.options.sort.none' | translate">
    <em [class]="currentSort | tableSortIcon"></em>
    <div class="mat-button-text-with-suffix">
      <span class="button-text">{{ currentSort.label | translate }}</span>
      <mat-icon class="button-caret">arrow_drop_down</mat-icon>
    </div>
  </button>
}
@if (appearance !== 'button') {
  <button mat-menu-item [mat-menu-trigger-for]="sortOptionsMenu">
    <em [class]="currentSort | tableSortIcon"></em>
    <div class="mat-button-text-with-suffix">
      <span class="button-text">{{ currentSort.label | translate }}</span>
      <mat-icon class="button-caret">arrow_drop_down</mat-icon>
    </div>
  </button>
}
<mat-menu #sortOptionsMenu>
  @for (mi of options; track mi) {
    <button mat-menu-item (click)="sort(mi)" [class.active]="mi.id === currentSort.id">
      <em [class]="mi | tableSortIcon"></em>
      <span>{{ mi.label | translate }}</span>
    </button>
  }
</mat-menu>
